import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TslDialog, TslToastrService } from '@tesla/ng-tds';
import { ContextVerbiage, SupplierMSME } from 'app/profile/models/supplier.model';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { OnboardingState } from 'app/profile/store/state/onboarding.state';
import { SupplierTasksState } from 'app/profile/store/state/supplier-tasks.state';
import { I18nService } from 'app/shared/services/i18n.service';
import * as MasterDataSelectors from "../../../store/selectors/masterdata.selector";
import { OnboardingDocument, TaskStatus } from 'app/profile/models/onboarding.model';
import { SupplierTaskResponse, SupplierTaskStep } from 'app/profile/models/suppliertasks.model';
import { MsmeComponent } from 'app/common/msme/msme.component';

@Component({
  selector: 'app-msme-task-wrapper',
  templateUrl: './msme-task-wrapper.component.html',
  styleUrls: ['./msme-task-wrapper.component.scss']
})
export class MsmeTaskWrapperComponent implements OnInit {

  supplierCode: string;
  taskId: number;
  isLoaded: boolean = false;
  taskStatus: string;
  onboardingTab: string = 'MSME';
  contextVerbiage: ContextVerbiage;
  taskInfo: SupplierTaskStep;
  rejectionDetails: any;
  msmeDetails: any;
  hideContactDocumentSection: boolean = false;
  requiredDocuments: OnboardingDocument[] = [];
  requestType: string;
  taskConfiguration: any;
  @ViewChild('msmeEditComponent', { static: false }) msmeEditComponent: MsmeComponent;
  @Input('supplierCode') set _supplierCode(val: string) { if (val && val.trim() != "") this.supplierCode = val; };
  @Input('taskId') set _taskId(val: number) { if (val) this.taskId = val; };
  @Input('isSidePanelMode') isSidePanelMode: boolean = false;
  @Output() onSave: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private route: ActivatedRoute,
    private onboardingStore: Store<OnboardingState>,
    private matDialog: MatDialog,
    private tasksStore: Store<SupplierTasksState>,
    private supplierStateService: SupplierStateService,
    private tslDialog: TslDialog,
    private taskService: SupplierTaskService,
    private toaster: TslToastrService,
    private router: Router,
    private translate: I18nService,
  ) { }

  ngOnInit(): void {
    this.route?.parent?.params?.subscribe(params => {
      if (params?.code && params?.portalTaskId) {
        this.supplierCode = params.code;
        this.taskId = params.portalTaskId;
      }
    });

    this.onboardingStore.select(MasterDataSelectors.SelectContextVerbiage).subscribe(contextVerbiage => this.contextVerbiage = contextVerbiage);

    // get task details by task type. 
    this.taskService.getSupplierTaskStep(this.supplierCode, this.taskId, this.onboardingTab).subscribe(taskInfo => {
      if (taskInfo && taskInfo.taskConfiguration) {
        this.taskInfo = taskInfo;
        this.taskConfiguration = taskInfo.taskConfiguration;
        this.requestType = this.taskInfo?.taskConfiguration?.SupplierRequestType;
        if(this.requestType) this.requestType = this.requestType[0].toLocaleLowerCase() + this.requestType.substring(1);
        this.requiredDocuments = taskInfo.taskConfiguration?.Documents;
        this.hideContactDocumentSection = this.requiredDocuments?.length > 0;
        this.taskStatus = taskInfo.taskStatus;
        this.rejectionDetails = taskInfo?.rejectionDetails;
        if (this.taskStatus != TaskStatus.Completed && taskInfo.portalTaskResponse != null) {
          this.msmeDetails = taskInfo.portalTaskResponse;
        }
        this.isLoaded = true;
      }
    });
  }

  onSubmit() {
    // on submit action
    this.msmeEditComponent.submit();
  }

  postInformation(msmeDetails: SupplierMSME) {
    let body = { ...msmeDetails };

    if(body?.DocumentInfos?.length > 0)
    {
      body?.DocumentInfos.forEach(x => {
        x.FormGroup = null;
      })
    }

    var response: SupplierTaskResponse = {
      id: this.taskId,
      supplierCode: this.supplierCode,
      taskResponseJson: JSON.stringify(body)
    }
    this.taskService.postSupplierTaskStepResponse(this.supplierCode, response).subscribe(res => {
      if (res) {
        this.toaster.success(this.translate.get('Submitted successfully!'));
        if (this.isSidePanelMode) this.onSave.emit(true);
        else this.router.navigate([`${this.supplierCode}`, "Onboarding", "Home"]);
      }
      else {
        this.toaster.error(this.translate.get('Something went wrong!'));
      }
    });
  }

}
